import { createReducer, on } from '@ngrx/store';
import { IInternationalCurrenciesState, initialUIState } from './international-currencies.state';
import {
  toggleInternationalCurrenciesLoading,
  loadInternationalCurrenciesSuccess,
  loadInternationalCurrenciesFailure,
} from './international-currencies.actions';

export const internationalCurrenciesReducer = createReducer(
  initialUIState,
  on(toggleInternationalCurrenciesLoading, (state, { isLoading }) => ({
    ...state,
    isLoading,
  })),
  on(loadInternationalCurrenciesSuccess, (state, { internationalCurrencies }) => ({
    ...state,
    list: internationalCurrencies,
    isLoading: false,
  })),
  on(loadInternationalCurrenciesFailure, (state) => ({
    ...state,
    isLoading: false,
  })),
);